import { gql } from '@apollo/client';

import { SHOWROOM_INFO, SHOWROOM_SECTION_INFO, SHOWROOM_SECTION_INFO_WITH_ROWMEDIAIDS } from '../queries';

export const IS_EDITOR_MODE = gql`
	query isEditorMode {
		showroom @client {
			editor {
				isOpen
				showroomId
				step
				currentSection
				displaySectionOptions
				showroomParams {
					name
					downloadEnabled
					downloadPdfEnabled
					requestSamplesEnabled
					samplesDepartmentId
					displayHeroMedia
					displayHeroContent
					language
					library
					librarySeason
					libraryCollection
					heroTitle
					heroContent
					heroFontColor
					heroBackgroundColor
					heroMedia {
						mediaType
						publicId
						publicUrl
					}
					pdfs {
						mediaType
						publicId
						publicUrl
						originalFilename
						createdAt
					}
					sections {
						id
						name
						rows {
							medias {
								mediaId
								mediaType
								publicId
								cloudinaryVersion
								width
								height
								originalFilename
								createdAt
								isSample
							}
						}
						options {
							spacing
							fullWidth
							displayLabel
							zoomLayer
							productLayer
							productLayerSettings {
								galleriesFields
								samplesFields
							}
							globalSelectedFilters {
								galleriesFields
								samplesFields
							}
						}
						rowMediaIds {
							id
							mediaIds
						}
						loaded
						loading
					}
					prContacts {
						name
						jobTitle
						email
						phone
					}
				}
			}
		}
	}
`;

export const CREATE_SHOWROOM = gql`
	mutation createShowroom(
		$name: String!
		$params: ShowroomUpdateParams
	) {
		createShowroomV2(
			name: $name
			params: $params
		) {
			...ShowroomInfo,
			password
			sections {
				...ShowroomSectionInfo
			}
		}
	}
	${SHOWROOM_INFO},
	${SHOWROOM_SECTION_INFO}
`;

export const UPDATE_SHOWROOM = gql`
	mutation updateShowroom(
		$_id: ID!
		$name: String!
		$params: ShowroomUpdateParams
		$updatePassword: Boolean
	) {
		updateShowroomV2(
			_id: $_id
			name: $name
			params: $params
			updatePassword: $updatePassword
		) {
			...ShowroomInfo,
			password
			sections {
				...ShowroomSectionInfoWithRowMediaIds
			}
		}
	}
	${SHOWROOM_INFO},
	${SHOWROOM_SECTION_INFO_WITH_ROWMEDIAIDS}
`;

export const UPLOAD_SHOWROOM_HERO = gql`
	mutation uploadShowroomHero {
		uploadShowroomHero
	}
`;

export const SELECTED_LIBRARY_MEDIAS_EDITOR = gql`
	query getLibrarySelectedMediasEditor {
		librarySelectedMedias @client {
			id
			mediaType
			name
			cloudinaryId
			cloudinaryVersion
			createdAt
			width
			height
			isSample
		}
	}
`;

export const MEDIA_SECTION_SAMPLES_FIELDS = gql`
	query getMediaSectionSamplesFields($ids: [String]!) {
		mediasAvailableSamplesFields(ids: $ids) {
			name
		}
	}
`;

export const MEDIA_SECTION_GALLERIES_FIELDS = gql`
	query getMediaSectionGalleriesFields($ids: [String]!) {
		mediasAvailableGalleriesFields(ids: $ids) {
			name
		}
	}
`;

export const SHOWROOM_CURRENT_SECTION_NUMBER = gql`
	query getShowroomCurrentSectionNumber {
		showroom @client {
			editor {
				currentSection
			}
		}
	}
`;

export const SHOWROOM_SECTION_FILTERS = gql`
	query getShowroomSectionFilters {
		currentShowroomSection @client {
			options {
				globalSelectedFilters {
					galleriesFields
					samplesFields
				}
			}
		}
	}
`;

export const SHOWROOM_SECTION_MEDIA_IDS = gql`
	query getShowroomSectionMediasIds {
		currentShowroomSectionMedias @client {
			mediaId
		}
	}
`;

export const SHOWROOM_LOADING_MEDIA_FIELDS = gql`
	query getShowroomSectionLoadingMediaFields($id: String!) {
		showroomSection(id: $id) @client {
			loading
			loaded
			rowMediaIds {
				id
				mediaIds
			}
		}
	}
`;

export const SHOWROOM_GLOBAL_FILTERS = gql`
	query getShowroomGlobalFilters($mediaIds: [String]!) {
		showroomGlobalFilters(mediaIds: $mediaIds) {
			samplesFilters
			galleriesFilters
		}
	}
`;
